import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[moveToNext]',
  standalone: true
})
export class MoveToNextDirective {
  @Input() nextInput?: HTMLInputElement;
  @Input() prevInput?: HTMLInputElement;
  @Input() maxLengthDirective: number = 0;

  @HostListener('keyup', ['$event'])
  onKeyUp(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    if (event.key === 'Backspace' && input.value.length === 0 && this.prevInput) {
      setTimeout(() => this.prevInput!.focus(), 100);
    }
    else if (input.value.length >= this.maxLengthDirective && this.nextInput) {
      setTimeout(() => this.nextInput!.focus(), 100);
    }
  }
}
